import { Box, useTheme } from "@mui/material";

type SiteSwitchButtonProps = { url: string; label: string };
export const SiteSwitchButton = ({ url, label }: SiteSwitchButtonProps) => {
  const theme = useTheme();
  return (
    <Box
      component={"a"}
      sx={{
        p: "1rem 2.5rem",
        lineHeight: "1.0625rem",
        borderRadius: "1.125rem",
        textDecoration: "none",
        color: theme.palette.text.primary,
        padding: "1rem",
        background: "linear-gradient(258.19deg, #FA1C44 -36.43%, rgba(250, 28, 68, 0) 97.22%)",
        backdropFilter: "blur(27px)",
        border: "1px solid #FA1C44",
      }}
      href={url}
      target="_blank"
    >
      {label}
    </Box>
  );
};
